import { useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import {
	Command,
	CommandEmpty,
	CommandGroup,
	CommandInput,
	CommandItem,
	CommandList,
} from "./ui/command";
import { Check, ChevronsUpDown } from "lucide-react";

/**
 * Searchable single-select (combobox) built on Command + Popover.
 * options: [{ value, label, sublabel? }]
 */
export function SearchableSelect({
	value,
	onChange,
	options = [],
	placeholder = "Seleziona…",
	searchPlaceholder = "Cerca…",
	emptyText = "Nessun risultato",
	triggerClassName = "",
	showDetails = false,
}) {
	const [open, setOpen] = useState(false);
	const selected = options.find((o) => o.value === value);

	return (
		<Popover open={open} onOpenChange={setOpen}>
			<PopoverTrigger asChild>
				<button
					type="button"
					role="combobox"
					aria-expanded={open}
					className={`flex items-center justify-between gap-2 h-9 px-3 rounded-sm bg-card border border-border text-sm text-left ${triggerClassName}`}
				>
					<span
						className={`min-w-0 ${showDetails ? "py-1" : "truncate"} ${selected ? "" : "text-muted-foreground"}`}
					>
						<span
							className={showDetails ? "block break-words leading-snug" : ""}
						>
							{selected ? selected.label : placeholder}
						</span>
						{showDetails && selected?.sublabel && (
							<span className="block text-xs text-muted-foreground">
								{selected.sublabel}
							</span>
						)}
					</span>
					<ChevronsUpDown className="w-4 h-4 opacity-50 shrink-0" />
				</button>
			</PopoverTrigger>
			<PopoverContent
				className={`p-0 bg-card border-border w-[var(--radix-popover-trigger-width)] ${showDetails ? "min-w-[min(90vw,420px)] max-w-[90vw]" : "min-w-[220px]"}`}
				align="start"
			>
				<Command
					filter={(itemValue, search) =>
						itemValue.toLowerCase().includes(search.toLowerCase()) ? 1 : 0
					}
				>
					<CommandInput placeholder={searchPlaceholder} className="h-9" />
					<CommandList>
						<CommandEmpty>{emptyText}</CommandEmpty>
						<CommandGroup>
							{options.map((o) => (
								<CommandItem
									key={o.value}
									value={`${o.label} ${o.sublabel || ""} ${o.value}`}
									onSelect={() => {
										onChange(o.value);
										setOpen(false);
									}}
									className={`flex items-center gap-2 ${showDetails ? "whitespace-normal" : ""}`}
								>
									<Check
										className={`w-4 h-4 shrink-0 ${
											value === o.value ? "opacity-100 text-volt" : "opacity-0"
										}`}
									/>
									<span className="flex flex-col min-w-0">
										<span
											className={
												showDetails
													? "whitespace-normal break-words leading-snug"
													: "truncate"
											}
										>
											{o.label}
										</span>
										{o.sublabel && (
											<span
												className={`${showDetails ? "whitespace-normal" : "truncate"} text-xs text-muted-foreground`}
											>
												{o.sublabel}
											</span>
										)}
									</span>
								</CommandItem>
							))}
						</CommandGroup>
					</CommandList>
				</Command>
			</PopoverContent>
		</Popover>
	);
}
